import _ from 'lodash';
import { CompStructure } from '@wix/document-services-types';
import {
  PresetContentFieldRole,
  InjectionIgnoredTextData,
  createFlatStructureMap,
} from '@wix/editor-content-injector';
import {
  ComponentExtractor,
  FullHomepageStructure,
  PageStructure,
} from '../types';
import { collectPageStructures } from './aiInjectionsUtils';

const componentExtractor = (
  fieldRole: PresetContentFieldRole,
): ComponentExtractor => ({
  matches(compStructure: CompStructure): boolean {
    return (
      _.get(compStructure, 'contentRole.fieldRole') === fieldRole &&
      _.has(compStructure, 'data.id')
    );
  },
  extract(compStructure: CompStructure): [string, string] {
    return extractComponentData(compStructure);
  },
});

const injectionIgnoredTextExtractor = componentExtractor(
  PresetContentFieldRole.InjectionIgnoredText,
);

const copyrightsExtractor = componentExtractor(
  PresetContentFieldRole.Copyrights,
);

const legalPagesExtractor = componentExtractor(
  PresetContentFieldRole.LegalPages,
);

const extractors: ComponentExtractor[] = [
  injectionIgnoredTextExtractor,
  copyrightsExtractor,
  legalPagesExtractor,
];

export const getInjectionIgnoredComponents = (
  pageStructure: PageStructure | FullHomepageStructure,
): InjectionIgnoredTextData => {
  const structuresToInject = collectPageStructures(
    pageStructure?.sections,
    pageStructure,
  );

  const flatStructures = structuresToInject.flatMap(createFlatStructureMap);

  const injectionIgnoredTextComponents = flatStructures.reduce<
    [string, string][]
  >((acc, compStructure) => {
    const extractor = extractors.find((ext) => ext.matches(compStructure));
    if (extractor) {
      acc.push(extractor.extract(compStructure));
    }
    return acc;
  }, []);

  return new Map(injectionIgnoredTextComponents);
};

const extractComponentData = ({ data }: CompStructure): [string, string] => [
  data.id,
  data.text,
];
